// Types
import { ReviewTemplateTypeType, ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';
import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

export const defaultTemplates: ReviewTemplateType[] = [
  {
    name: 'FeedbackAI',
    description: 'Constructive feedback that writes itself for you, literally.',
    isCustom: false,
    isUsed: false,
    hidden: false,
    slug: FeedbackRecognitionTemplateTypes.feedbackGPT3Coach,
    templateType: ReviewTemplateTypeType.feedback,
    reviewFormTemplates: [],
    createdAt: '',
    userId: null,
  },
  {
    name: 'Strengths & Opportunities',
    description: 'Give constructive feedback',
    isCustom: false,
    isUsed: false,
    hidden: false,
    slug: FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate,
    templateType: ReviewTemplateTypeType.feedback,
    reviewFormTemplates: [],
    createdAt: '',
    userId: null,
  },
  {
    name: 'Blank',
    description: 'Give direct feedback',
    isCustom: false,
    isUsed: false,
    hidden: false,
    slug: FeedbackRecognitionTemplateTypes.feedbackBlankTemplate,
    templateType: ReviewTemplateTypeType.feedback,
    reviewFormTemplates: [],
    createdAt: '',
    userId: null,
  },
];
